import { Pipe, PipeTransform } from '@angular/core';

/** Formats long file names to smaller names */
@Pipe({ name: 'apFileName' })
export class ApNamePipe implements PipeTransform {
    /**
     * name: the Filename.
     * maxLength: the length at which the filename will be truncated.
     */
    transform(name: string, maxLength = 27): string {
        if (name.length > maxLength) {
            const prefix = name.substring(0, maxLength - 10);
            const postfix = name.substring(name.length - 10);
            return `${prefix}...${postfix}`;
        }
        return name;
    }
}
